export default (() => {

    function isOnMobileDevice () {
        return typeof window.orientation !== 'undefined';
    }

    // This should only be used for displaying instructional content around supported browsers
    // If support checks are required for functionality purposes, use feature detection instead
    function isBrowserSupported () {
      
        const browserCases = [
            // Safari - Webkit
            {
                inclusion: /Safari/,
                exclusion: /Chrome|CriOS|FxiOS/,
                separateVersionQuery: /Version/
            },
            // iOS browsers:
            // All browsers on iOS are currently made to use the WebKit rendering engine.
            // This may change in the future, so it's something we should keep an eye on.
            // https://www.macrumors.com/2022/12/14/apple-considering-non-webkit-iphone-browsers/
            { inclusion: /CriOS|FxiOS/},
            // Firefox Browser - Gecko
            {inclusion: /Firefox/},
            // Chrome/Chromium Browsers - Blink
            {inclusion: /Chrome|Chromium/}
        ];
        
        const { userAgent } = navigator;
        
        let isVersionSupported = true;
        
        for (const browserCase of browserCases) {
            if (browserCase.inclusion.test(userAgent) && !browserCase.exclusion?.test(userAgent)) {
                // The separateVersionQuery is a mechanism for matching browsers that separately
                // list their version numbers from the RenderingEngine/x.xx or BrowserName/x.xx convention - e.g. Safari
                const browserNames = userAgent.match(browserCase?.separateVersionQuery || browserCase.inclusion);
              
                const matchedBrowserName = userAgent.match(browserCase.inclusion)[0];
                const matchedBrowserVersion = _extractBrowserVersionFromUserAgent(userAgent, browserNames)[0];

                // Skip to next case if browser version not found
                if(!matchedBrowserVersion) continue;
                   
                isVersionSupported = _isVersionSupported(matchedBrowserVersion, matchedBrowserName);
       
                break;
            }
        }

        return isVersionSupported;
    }
      
    function _isVersionSupported(supportedVersion, browserName) {
        const [version] = supportedVersion.split('/').reverse();
  
        return parseFloat(version) >= wealthify.settings.supportedBrowsers[browserName];
    }

    function _extractBrowserVersionFromUserAgent(userAgent, browserNames) {
        return userAgent.match(`${browserNames.join('|')}+/[0-9|.]+`);
    }

    return {
        isOnMobileDevice,
        isBrowserSupported
    };
})();